
import Cookies from 'js-cookie'
import store from '@/store'
import { uploadLog } from '@/api/wx'

const TokenKey = 'aabb'

export function getToken() {
const rst = Cookies.get(TokenKey)
if (rst === 'ab') {
return null
} else {
return rst
}
}

export function setToken(token) {
Cookies.set(TokenKey, token, {
expires: 7
})
}

export function removeToken() {
console.log('removeToken')
uploadLog('Remove Token Now')
Cookies.set(TokenKey, 'ab', { expires: 1 })
}

export function resetToken() {
if (getToken()) {
return Cookies.set(TokenKey, getToken(), {
expires: store.getters.tokenExpired
})
}
}



// WEBPACK FOOTER //
// ./src/utils/auth.js